export default {
  global: {
    "config": {
      "changed": true,
      "title": "Global",
      "navSection": "general",
      "icon": "global",
      "image": "global.png"
    },
    "items": {
      "name": {
        "name": "eDNA Starter Theme"
      },
      "themeColors": {
        "color-1": "#5e78e5",
        "color-2": "#546cce",
        "color-3": "#4b60b7",
        "color-4": "#4154a0",
        "color-5": "#384889",
        "color-6": "#2f3c72",
        "color-7": "#25305b",
        "color-8": "#1c2444",
        "color-9": "#12182d",
        "color-10": "#090c16"
      },
      "statusColors": {
        "good": "#5e78e5",
        "neutral": "#fafafa",
        "bad": "#D64554"
      },
      "variousGradient": {
        "maximum": "#5e78e5",
        "center": "#95a7f1",
        "minimum": "#d64554"
      },
      "advanced": {
        "foreground": "#fafafa",
        "foregroundNeutralSecondary": "#666666",
        "backgroundLight": "#c5c5c5",
        "foregroundNeutralTertiary": "#a7a7a7",
        "background": "#FFFFFF",
        "backgroundNeutral": "#C8C6C4"
      },
      "textClassesCallout": {
        "fontFace": "Segoe UI",
        "fontSize": 18,
        "color": "#020f47"
      },
      "textClassesTitle": {
        "fontFace": "Segoe UI",
        "fontSize": 10,
        "color": "#020f47"
      },
      "textClassesHeader": {
        "fontFace": "Segoe UI",
        "fontSize": 10,
        "color": "#fafafa"
      },
      "textClassesLabel": {
        "fontFace": "Segoe UI",
        "fontSize": 10,
        "color": "#020f47"
      }
    }
  },
  globalStyles: {
    "config": {
      "changed": true,
      "title": "Global Styles",
      "navSection": "general",
      "icon": "globalStyles",
      "image": "globalStyles.png"
    },
    "items": {
      "background": {
        "color": "#FFFFFF",
        "transparency": 100
      },
      "outspacePane": {
        "backgroundColor": "#FFFFFF",
        "transparency": 0,
        "foregroundColor": "#252423",
        "titleSize": 12,
        "headerSize": 9,
        "checkboxAndApplyColor": "#F2C811"
      },
      "border": {
        "color": "#000000",
        "show": false,
        "radius": 0
      },
      "visualHeader": {
        "background": "#020f47",
        "foreground": "#efefef",
        "transparency": 60,
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        }
      },
      "visualTooltip": {
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "background": "#e6e6e6"
      },
      "filterCard": {
        "$id": "Applied",
        "foregroundColor": "#252423",
        "backgroundColor": "#FFFFFF",
        "textSize": 9,
        "transparency": 0
      }
    }
  },
  page: {
    "config": {
      "changed": true,
      "title": "Page",
      "navSection": "general",
      "icon": "page",
      "image": "page.png"
    },
    "items": {
      "outspace": {
        "color": "#FFFFFF",
        "transparency": 100,
        // "image": {
        //   "name": "",
        //   "url": "",
        //   "scaling": "Normal"
        // }
      },
      "background": {
        "color": "#FFFFFF",
        "transparency": 0,
        // "image": {
        //   "name": "",
        //   "url": "",
        //   "scaling": ""
        // }
      }
    }
  },

}